  const swiperCol6 =  new Swiper('.press-swiper-section', {
      slidesPerView: 5,
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next-new',
        prevEl: '.swiper-button-prev-new',
      },
      pagination: {
        el: '.swiper-pagination-new',
      },
      breakpoints: {
       
        600: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        }
      }
    });

    const swiperColnew = new Swiper('.video-rev-sec-inner', {
  slidesPerView: 3,
  spaceBetween: 30,
  freeMode: true, 
   grabCursor: true,
 mousewheel: { forceToAxis: true, invert: true },
  breakpoints: {
    600: {
      slidesPerView: 1.3,
      spaceBetween: 20,
     
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 30,
     
    }
  }
});



  document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        faqItems.forEach(i => i.classList.remove('active'));
        if (!isActive) item.classList.add('active');
      });
    });
  });



document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.specs-accordion-header').forEach(header => {
    header.addEventListener('click', function() {
      const panel = document.querySelector(`#${header.dataset.target}`);
      const toggle = header.querySelector('.specs-toggle');

      if (header.classList.contains('specs-active')) {
        header.classList.remove('specs-active');
        panel.classList.remove('open');
        toggle.classList.remove('specs-active');
      } else {
        // Close all other panels
        document.querySelectorAll('.specs-accordion-header').forEach(otherHeader => {
          otherHeader.classList.remove('specs-active');
          const otherPanel = document.querySelector(`#${otherHeader.dataset.target}`);
          otherPanel.classList.remove('open');
          otherHeader.querySelector('.specs-toggle').classList.remove('specs-active');
        });

        // Open the clicked panel
        header.classList.add('specs-active');
        panel.classList.add('open');
        toggle.classList.add('specs-active');
      }
    });
  });
});


  function increaseQuantity(input) {
    input.stepUp(); 
   changeLineItemQuantity(input);
}
function decreaseQuantity(input) {
    input.stepDown(); 
 changeLineItemQuantity(input);

}
     function changeLineItemQuantity(input) {
    const lineKey = input.getAttribute('data-line-key');
    const targetQuantity = parseInt(input.value);
    const lineItemQuantityElement = input.closest("line-item-quantity");
    lineItemQuantityElement._changeLineItemQuantity(lineKey, targetQuantity);
}


(function() {
  

  async function getCart() {
    const res = await fetch(`/cart.js?ts=${Date.now()}`, { credentials: 'same-origin' });
    return res.json();
  }

  async function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function getIdsFromDOM() {
    const container = document.querySelector('.package-protection');
    if (!container) return null;
    return {
      productId: parseInt(container.dataset.shipProductId, 10),
      variantId: parseInt(container.dataset.shipVariantId, 10),
      checkbox: container.querySelector('.shippingProtectionToggle')
    };
  }

  function findProtection(cart, productId, variantId) {
    // Prefer variant match (more precise), fallback to product match
    return cart.items.find(i => (variantId && i.variant_id === variantId) || i.product_id === productId);
  }

  let ensureLock = false;
  async function ensureProtectionNotAlone() {
    if (ensureLock) return;
    const ids = getIdsFromDOM();
    if (!ids) return;

    ensureLock = true;
    try {
      const cart = await getCart();
      const protection = findProtection(cart, ids.productId, ids.variantId);
      if (!protection) { ensureLock = false; return; }

      const nonProtectionCount = cart.items.filter(i =>
        !((ids.variantId && i.variant_id === ids.variantId) || i.product_id === ids.productId)
      ).length;

      if (nonProtectionCount === 0) {
        await removeByKey(protection.key);
        // Best-effort UI sync
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // If there’s a checkbox, reflect state
        if (ids.checkbox) ids.checkbox.checked = false;
      }
    } catch (err) {
      console.warn('ensureProtectionNotAlone failed:', err);
    } finally {
      ensureLock = false;
    }
  }



  async function handleProtectionChange(e) {
    const checkbox = e.target;
    const container = checkbox.closest('.package-protection');
    if (!container) return;

    const productId = parseInt(container.dataset.shipProductId, 10);
    const variantId = parseInt(container.dataset.shipVariantId, 10);
    const isChecked = checkbox.checked;

    try {
      if (isChecked) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      } else {
        const cart = await getCart();
        const lineItem = findProtection(cart, productId, variantId);
        if (lineItem) await removeByKey(lineItem.key);
      }

      await ensureProtectionNotAlone();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      console.error('Shipping protection toggle failed:', err);
      checkbox.checked = !isChecked;
    }
  }


  const _origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await _origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url)) {
        // Run after the cart endpoint finishes
        Promise.resolve().then(() => ensureProtectionNotAlone());
      }
    } catch (e) {
      // noop
    }
    return res;
  };

 

  let lastCheck = 0;
  setInterval(() => {
    const now = Date.now();
    if (now - lastCheck < 1500) return;
    lastCheck = now;
    ensureProtectionNotAlone();
  }, 2000);


  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('shippingProtectionToggle')) {
      handleProtectionChange(e);
    }
  });

  // Initial pass on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureProtectionNotAlone);
  } else {
    ensureProtectionNotAlone();
  }

})();

